/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { UploadMarketImagesResponse, UploadMarketImagesVars } from '../openapi-types.gen.js';

export type { UploadMarketImagesResponse, UploadMarketImagesVars } from '../openapi-types.gen.js';

export const useUploadMarketImages = createMutationHook<UploadMarketImagesVars, UploadMarketImagesResponse, unknown>({
  specName: 'useUploadMarketImages',
  path: '/v1/markets/images/upload',
  method: 'POST',
  resolveUrl: (vars: UploadMarketImagesVars) => `/v1/markets/images/upload`,
  buildBody: (vars: UploadMarketImagesVars) => {
    const fd = new FormData();
    for (const file of vars.files) fd.append('files', file);
    return fd;
  },
  parseResponse: (raw: unknown): UploadMarketImagesResponse => raw as UploadMarketImagesResponse,
  
  
  
});
